import React from "react";
import { _goToRoot } from "routers/helper";
import { useNavigation } from "@react-navigation/native";

import { View } from "react-native";

import Text from "components/Text";
import Button from "components/Button";
import HeaderLayout from "components/HeaderLayout";

import { colors } from "assets/constants";
import { mq } from "utils";
import css from "styles";

const Header: React.FC<HeaderT> = ({ title, onBack, leftIcon, renderLeft }) => {
  const { goBack } = useNavigation();

  return (
    <HeaderLayout>
      <View style={{ ...css.growContainer, ...css.rowCenterAlign }}>
        {renderLeft ? (
          renderLeft()
        ) : (
          <Button
            square={mq(45)}
            onPress={onBack || goBack}
            bgColor={colors.transparent}
            icon={{
              name: "chevron-left",
              color: colors.text.normal,
              size: 23,
              ...leftIcon,
            }}
          />
        )}
        <View style={css.growContainer} />
        <Text size={"lg"} weight="bold" color={colors.text.normal}>
          {title}
        </Text>
        <Button
          bgColor={colors.transparent}
          onPress={_goToRoot}
          square={45}
          style={{ bottom: 2 }}
          icon={{
            type: "antDesign",
            name: "home",
            color: colors.text.normal,
          }}
        />
      </View>
    </HeaderLayout>
  );
};

export default Header;
